import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild,Output,EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import {FileManagerService} from '../services/fileManager.services';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss']
})

export class InboxComponent implements OnInit {
  databaseId: string;
  organizationId: string;
  currentUser: any;
  selection = new SelectionModel<any>(true, []);
  _returnList: any[] = [];
  _returnColumns: any[] = [];
  @Output() documentViewer = new EventEmitter<boolean>();
  Module:string;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength: any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  noRecordFound:boolean = false;
  SelectedRecordForDeleFav:boolean=false;
  selectedRecordDeleteArray: any = [];
  pageIndex: any;
  pageSize: any;
  SingleDeleteRecord:any={isdelete:false,RecordId:""};
  dataSource: any;
  displayedColumns:Array<any>=[];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  inboxItemsList: any[] = []; 
  folderId:number =0;
  OfficeIDList: any=[];
  myOfficeID: any;
  
  constructor(private router: Router,private dialog: MatDialog,private fileManagerService:FileManagerService,
    private reusableClass:ReusableClasses,private encryptionAlgo: EncryptionService,
    private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef,
    private loaderService: LoaderService) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
     }

  ngAfterContentChecked() {    
     this.cdr.detectChanges();
  }

  ngOnInit(): void {    
    this.paginatorTotalLength=0;
    this.getFileManagerInboxItems(this.pageModelData);
    this.setDisplayedColumns();   
    this.Module = "Inbox"; 
    this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
  } 
   
  pageEventPropogate(pageData: PageEvent) { 
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue;
    this.getFileManagerInboxItems(this.pageModelData);     
  }

   getFileManagerInboxItems(pageData){
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    var ReqModel = {
      pageIndex:this.pageModelData.pageIndex,
      pageSize:this.pageModelData.pageSize,
      searchKey:this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.fileManagerService.getFilemanagerInboxItems(ReqModel).subscribe(response=>{
     if(response.data!=null){
       this.dataSource = new MatTableDataSource<any>();      
       this.inboxItemsList = response.data.fileManagerInboxItem;
       this.dataSource.data =this.inboxItemsList;
       this.dataSource.sort = this.sort; 
       this.paginatorTotalLength = response.data.count;
       this.pageModelData.pageIndex = response.data.pageIndex;
       this.pageIndex = response.data.pageIndex;
       this.pageSize = pageData.pageSize;
       if(this.inboxItemsList.length >0){
         this.noRecordFound=false;
       }else{
        this.noRecordFound=true;
        this.SelectedRecordForDeleFav=false;
        this.selection.clear();
       }
       this.loaderService.hide();
     }
     else{
      this.paginatorTotalLength=0;
      this.loaderService.hide();
     }
    });
   }
   
   setDisplayedColumns() {
    this.displayedColumns  = ['fileManagerInboxID','name', 'receivedOn', 'action'];
  }
 
  SearchFilter() { 
    this.selection.clear(); 
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue; 
    if(this.pageModelData.searchValue==""){
      return;
     }
    this.getFileManagerInboxItems(this.pageModelData);
  }

  Search(filterValue) {
    this.selection.clear(); 
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue=filterValue.trim();
    this.getFileManagerInboxItems(this.pageModelData);
  }

 /** Whether the number of selected elements matches the total number of rows. */
 isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.data.length;
  return numSelected === numRows;
}

/** Selects all rows if they are not all selected; otherwise clear selection. */
masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => 
        {
        this.selection.select(row)});
        this.selectedRecordDeleteArray=[];    
      
        if (this.selection.selected.length > 0) {
          for (let i = 0; i < this.selection.selected.length; i++) {          
              let ReqModel = {
                selectedRecord: this.selection.selected[i].projectInboxSentId
                };
               this.selectedRecordDeleteArray.push(ReqModel);    
          }
          this.SelectedRecordForDeleFav = true;
        }
        else {
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
        }     
}

isAllSelectedRow(event, element) {
    let ReqModel = {
      selectedRecord: element.projectInboxSentId
    };
    if (event.checked) {
      this.selectedRecordDeleteArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDeleteArray.findIndex(
        (itm) => itm.selectedRecord === element.projectInboxSentId
      );
      if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
    }

    if (this.selectedRecordDeleteArray.length > 0) {
      this.SelectedRecordForDeleFav = true;
    }
    else {
      this.SelectedRecordForDeleFav = false;
      this.selectedRecordDeleteArray = [];
    }
 
}

SelectedDocumentForFileManager:any=[];

openDocumentViewer(message: boolean,document,templateRef: TemplateRef<any>) {
  this.folderId = document.fileManagerItemID;
  this.SelectedDocumentForFileManager=[];
    var ReqModel={
      documentID:document.fileManagerItemID,
      documentPath:document.azureblobPath,      
    }
  this.SelectedDocumentForFileManager.push(ReqModel);
  //this._dataSharingService.sendSelectedDocumentForFileManager(ReqModel);
  this.documentViewer.emit(message);
  this.dialog.open(templateRef);
}

getCloseDocumentViewer(message: boolean) {
  this.SelectedDocumentForFileManager=[];
  this.documentViewer.emit(false);
  this.dialog.closeAll();
}

}
